import { axiosInstance } from '@src/services/common';

export async function getUserInfo() {
  const response = await axiosInstance.get<UserInfo>(`/gm/user-info`);

  return response.data;
}
